import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { PromotionBoosterLinkableType, useMixins } from '@/modules/promotion/booster/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionBoosterEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify } = useCrudActions();

    const { fetchLinkableItems, promotionOption, getItemLink, getItemName } = useMixins();

    const model = reactive({
        id: route.params?.id || null,
        name: null,
        promotionId: null,
        boosters: []
    });

    const validations = {
        name: { required },
        promotionId: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        canExecute: () => model.id != null,
        request: () => promotionService.booster.get(model.id),
        onSuccess: ({ data }) => {
            model.name = data.name;
            model.promotionId = data.promotionId;
            model.boosters = data.boosters.map((booster: any) => ({
                ...booster,
                name: getItemName(PromotionBoosterLinkableType.BoosterItem, booster.type),
                link: getItemLink(PromotionBoosterLinkableType.BoosterItem, booster.type)
            }));
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.BOOSTER.INDEX })
    });

    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () => promotionService.booster.update(model.id, model.name),
            onSuccess: () => router.push({ name: ROUTE_NAME_PROMOTION.BOOSTER.INDEX })
        })
    };

    onMounted(async () => {
        await fetchLinkableItems();
        await fetch();
    });

    return { v$, model, actions, promotionOption };
}
